import React, { useState, useRef, useEffect } from "react";

interface ICardProps {
  title: string;
  children: React.ReactNode;
  scrollToView?: boolean;
  className?: string;
}

export default function Card({
  title,
  children,
  scrollToView,
  className,
}: ICardProps) {
  const [fold, setFold] = useState<boolean | undefined>(undefined);
  const containerRef = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   // 创建一个ResizeObserver来监听容器高度变化
  //   const observer = new ResizeObserver((entries) => {
  //     for (const entry of entries) {
  //       const height = entry.contentRect.height;
  //       const isFold = height > 320;
  //       setFold(isFold);
  //       if (isFold) {
  //         observer.disconnect();
  //       }
  //     }
  //   });

  //   // 开始观察容器
  //   if (containerRef.current) {
  //     observer.observe(containerRef.current);
  //   }

  //   // 清理函数
  //   return () => {
  //     observer?.disconnect();
  //   };
  // }, []);

  useEffect(() => {
    // 如果设置了scrollToView，则滚动到该Card
    if (scrollToView && containerRef.current) {
      containerRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [scrollToView]);

  return (
    <div className={className} ref={containerRef}>
      <div
        className={`relative px-4 py-4 rounded-4 bg-white ${fold ? "max-h-80 overflow-y-hidden" : ""
          }`}
      >
        <div className="relative text-4 text-mx-secondary font-500 h-5.5">
          {title}
          <div className="absolute left-0 bottom-0.25 w-8 h-1.5 bg-gradient-to-r from-#80B0FF  to-#A28CE280/50 rounded-25 opacity-40"></div>
        </div>
        {children}
        {fold && (
          <div className="absolute bottom-0 left-0 h-25 w-full [background-image:linear-gradient(to_top,#FFFFFF_0%,#FFFFFF_50%,rgba(255,255,255,0)_100%)]"></div>
        )}
        {fold && (
          <div
            className="absolute w-fit left-0 right-0 bottom-4 mx-auto h-7 lh-7 text-mx-quaternary text-3"
            onClick={() => setFold(false)}
          >
            查看全部
          </div>
        )}
      </div>
    </div>
  );
}
